/**
 * Textos del Catàleg (`es`): ajunta els fitxers de cada tall. Cablejat a `es.ts` amb un sol
 * `...catalegEs`; així cada tall edita només el seu fitxer.
 */

import { supplierArticlesEs } from './supplierArticles.es.js';
import { ftRequestEs } from './ftRequest.es.js';
import { articleRestrictionsEs } from './articleRestrictions.es.js';

export const catalegEs = {
  ...supplierArticlesEs,
  ...ftRequestEs,
  ...articleRestrictionsEs,
} as const;
